import React from 'react';
import { Spring } from 'react-spring/renderprops';
import NumberFormat from 'react-number-format';

import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicControlGroup from '../../../../components/BasicControlGroup';
import BasicNavLinkButton from '../../../../components/BasicNavLinkButton';
import LinkButton from '../../../../components/LinkButton';
import PanelContainer from '../../../../components/PanelContainer';
import ReadMore from '../../../../components/ReadMore';
import {ANIMATION_TIMEOUT_INOUT} from '../../../../constants/animation';
import LinkBuilder from '../../../../helpers/link-builder';

const ShortlistItem = props => {
  const {
    data: { ShortlistID, Name, Description, Professionals },
    actions: { onDelete, onEdit, onViewStatistics, onShare },
    isEditable,
  } = props;

  const handleOnDelete = () => {
    onDelete(ShortlistID);
  };

  const handleOnEdit = () => {
    onEdit({ ShortlistID, Name, Description });
  };

  const handleOnViewStatistics = () => {
    onViewStatistics(ShortlistID);
  };

  const handleOnShare = () => {
    onShare(ShortlistID, Name);
  };

  const shortlistLink = LinkBuilder.getShortlistLink(ShortlistID);

  return (
    <Spring
      from={{ opacity: 0 }}
      to={{ opacity: 1 }}
      config={{ duration: ANIMATION_TIMEOUT_INOUT }}
    >
      {props => (
        <PanelContainer
          styles={(props, { paddingTop: '25px', marginBottom: '10px' })}
        >
          <div className="shortlist-item">
            <div className="shortlist-item__controls">
              {isEditable && (
                <BasicControlGroup>
                  <LinkButton text="Delete" controlFunc={handleOnDelete} />
                  <LinkButton text="Edit" controlFunc={handleOnEdit} />
                </BasicControlGroup>
              )}
            </div>

            <div className="shortlist-item__content">
              <div className="shortlist-item__highlights">
                <div className="shortlist-item__highlight">
                  <div className="shortlist-item__block">
                    <div className="shortlist-item__name">Professionals</div>
                    <div className="shortlist-item__value">
                      {
                        <NumberFormat
                          thousandSeparator
                          value={Professionals}
                          displayType={'text'}
                        />
                      }
                    </div>
                  </div>
                </div>
                <div className="shortlist-item__highlight">
                  <div className="shortlist-item__block">
                    <div className="shortlist-item__name">Name</div>
                    <div className="shortlist-item__value">{Name}</div>
                  </div>
                </div>
              </div>
              {Description && (
                <div className="shortlist-item__description">
                  <ReadMore text={Description} readMoreCharacterLimit={300} />
                </div>
              )}
            </div>

            <div className="proccess-item__footer">
              <BasicButtonGroup>
                {Professionals > 0 && (
                  <BasicNavLinkButton
                    to={shortlistLink}
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={600}
                    btnText="View Professionals"
                    btnArrow={false}
                    btnBg="#fff"
                    btnHoverBg="#f40"
                  />
                )}

                {Professionals > 0 && (
                  <BasicButton
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={600}
                    btnText="View Statistics"
                    btnArrow={false}
                    controlFunc={handleOnViewStatistics}
                    btnBg="#fff"
                    btnHoverBg="#f40"
                  />
                )}

                {isEditable && (
                  <BasicButton
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={600}
                    btnText="Share"
                    btnArrow={false}
                    controlFunc={handleOnShare}
                    btnBg="#fff"
                    btnHoverBg="#f40"
                  />
                )}
              </BasicButtonGroup>
            </div>
          </div>
        </PanelContainer>
      )}
    </Spring>
  );
};

export default ShortlistItem;
